import {Serializable, Serialize, SerializeProperty} from 'ts-serializer';

@Serialize({})
export class SmartPrediction extends Serializable {
  @SerializeProperty()
  public partDescription: string;

  @SerializeProperty()
  public companyPartNumber: string;

  @SerializeProperty()
  public aircraftNumber: string;

  @SerializeProperty()
  public lastVendor: string;

  @SerializeProperty()
  public manufacturerSerialNumber: string;

  @SerializeProperty()
  public companySerialNumber: string;

  @SerializeProperty()
  public installedAtStation: string;

  @SerializeProperty()
  public installedByDepartment: string;

  @SerializeProperty()
  public removedAtStation: string;

  @SerializeProperty()
  public removedByDepartment: string;

  @SerializeProperty()
  public installCount: number;

  @SerializeProperty()
  public fleetModelCode: string;

  @SerializeProperty()
  public workbenchPartNoun: string;

  @SerializeProperty()
  public workbenchPartDescription: string;

  @SerializeProperty()
  public ataDescription: string;

  @SerializeProperty()
  public position: string;

  @SerializeProperty()
  public cpn_mtbur_5_years;

  @SerializeProperty()
  public cum_avg_tsi_by_csn_at_inst;

  @SerializeProperty()
  public flight_tsi;

  @SerializeProperty()
  public flight_tso;

  @SerializeProperty()
  public softSpecBreach;

  @SerializeProperty()
  public ohSoftHours: number;

  @SerializeProperty()
  public ohSoftCycles: number;

  @SerializeProperty({
    map: 'REMOVE_1'
  })
  public removalFlagOne: number;

  @SerializeProperty({
    map: 'REMOVE_2'
  })
  public removalFlagTwo: number;

  @SerializeProperty({
    map: 'REMOVE_3'
  })
  public removalFlagThree: number;

  @SerializeProperty({
    map: 'REMOVE_6',
  })
  public removalFlagSix: number;

  @SerializeProperty({
    map: 'REMOVE_7',
  })
  public removalFlagSeven: number;

  @SerializeProperty({
    map: 'REMOVE_8',
  })
  public removalFlagEight: number;

  @SerializeProperty({
    map: 'REMOVE_9',
  })
  public removalFlagNine: number;

  @SerializeProperty({
    map: 'REMOVE_10',
  })
  public removalFlagTen: number;

  static getOriginalColumnName(columnName: string): string {
    const serializeMap = SmartPrediction.prototype._serializeMap;
    if (serializeMap && serializeMap[columnName] && serializeMap[columnName]['map']) {
      return serializeMap[columnName]['map'];
    }

    return columnName;
  }

  static getAllFieldNames(): string[] {
    return Object.keys(SmartPrediction.prototype._serializeMap);
  }

  public getRemovalFlags() {
    return {
      removalFlagOne: this.removalFlagOne,
      removalFlagTwo: this.removalFlagTwo,
      removalFlagThree: this.removalFlagThree,
      removalFlagSix: this.removalFlagSix,
      removalFlagSeven: this.removalFlagSeven,
      removalFlagEight: this.removalFlagEight,
      removalFlagNine: this.removalFlagNine,
      removalFlagTen: this.removalFlagTen,
    }
  }

  public rawRemovalFlagString(): string {
    return SmartPrediction.getOriginalColumnName(this.getTriggeredRemovalFlag())
  }

  public getTriggeredRemovalFlag(): string | null {
    const removalFlags = this.getRemovalFlags()
    let triggeredRemovalFlag: string = null;

    Object.keys(removalFlags).forEach(removalFlag => {
      if (removalFlags[removalFlag] == 1) {
        triggeredRemovalFlag = removalFlag
        return
      }
    });

    return triggeredRemovalFlag;
  }

  get removalFlagString(): string {
    let removalFlag = 'None'

    const removalFlags = Object.keys(this).filter(key => key.includes("removalFlag"))
    removalFlags.forEach(flag => {
      if (this[flag]) {
        removalFlag = flag.replace('removal', '')
      }
    })

    return removalFlag;
  }

}
